<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon material-school_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">ブランド管理</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'brand' : 'home' }">戻る</router-link>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <td colspan="2">
              <button type="button" class="btn btn-edit" @click="edit" v-show="allowEditingBrand">
                編集
              </button>
              <button type="button" class="btn" @click="changePassword">
                パスワード変更
              </button>
            </td>
          </tr>
          <tr>
            <th scope="row" width="30%">法人名（法人ID）</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランドID</th>
            <td>{{ currentBrand.uid }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名</th>
            <td>{{ currentBrand.name }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名(フリガナ)</th>
            <td>{{ currentBrand.nameReading }}</td>
          </tr>
          <tr>
            <th scope="row">郵便番号</th>
            <td>{{ currentBrand.postalCode }}</td>
          </tr>
          <tr>
            <th scope="row">都道府県 市区町村</th>
            <td>{{ currentBrand.state }}</td>
          </tr>
          <tr>
            <th scope="row">番地・建物名</th>
            <td>{{ currentBrand.address }}</td>
          </tr>
          <tr>
            <th scope="row">電話番号</th>
            <td>{{ currentBrand.phone }}</td>
          </tr>
          <tr>
            <th scope="row">FAX番号</th>
            <td>{{ currentBrand.fax }}</td>
          </tr>
          <tr>
            <th scope="row">メールアドレス</th>
            <td>{{ currentBrandEmail }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import store from '@/store/index.js';
import { basicPresent, basicCorporationNameIdPresent } from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('brand/fetchBrand', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  mounted() {
    // 登録・編集の入力情報を初期化
    this.clearEditingBrand();
  },
  computed: {
    currentBrand() {
      return this.brand.brand;
    },
    currentCorporationDisplay() {
      if (this.currentBrand.corporation) {
        return basicCorporationNameIdPresent(this.currentBrand.corporation);
      }
      return '';
    },
    currentBrandEmail() {
      return basicPresent(this.currentBrand.email);
    },
    ...mapState(['brand']),
    ...mapGetters('role', ['allowEditingBrand']),
  },
  methods: {
    edit() {
      if (this.id) {
        this.$logger.debug('Edit Brand ID ' + this.id);
        this.$router.push({ name: 'brand-id-edit', params: { id: this.id } });
      }
    },
    changePassword() {
      if (this.id) {
        this.$logger.debug('Change Password ID ' + this.id);
        this.$router.push({ name: 'brand-id-change-password', params: { id: this.id } });
      } else {
        this.$logger.debug('Change Password');
        this.$router.push({ name: 'brand-change-password' });
      }
    },
    ...mapActions('brand', ['clearEditingBrand']),
  },
};
</script>

<style scoped>
.btn {
  margin-left: 0px;
}
.btn-edit {
  margin-right: 20px;
}
</style>
